// extracted by mini-css-extract-plugin
export default {"modalTitle":"modalTitle___C7vQn","modalMessage":"modalMessage___QpenT","modalButtons":"modalButtons___QkXPS","pageFormButtons":"pageFormButtons___hFBAj"};